<template>
  <div class="content">
    <div class="row">
      <div class="container">
        <p v-bind:style="[bannerPlaceHolderWithoutNBWeb.styles]" class="nb-message" 
          v-if="bannerPlaceHolderWithoutNBWeb && Object.keys(bannerPlaceHolderWithoutNBWeb).length">
          {{bannerPlaceHolderWithoutNBWeb.text}}
        </p>
      </div>
      <div class="col-12">
        <div class="form-check-label"></div>
          <label class="w-100 custom-radio" v-for="(bankItem, index) in this.netBankingIconOutageData" :key="index">
            <div class="waltcol026 p-2" :style="bankItem.isOutageApplicable && bankItem.isOutageApplicable === 'DOWN' ? `background-color: ${bannerPlaceHolderFoPayMethodDown.banner_color };` : ''">
              <div class="wal15">
                <div class="left_img65">
                  <div class="image-wrapper" :class="imgHighLight === bankItem.value ? 'image-wrapper-highlight' : ''">
                  <img :data-src="'data:image/png;base64,' + bankItem.image" :alt="bankItem.name"/>
                  </div>
                  <span style="width:80px; text-align:left">{{ bankItem.name }}</span>
                </div>
                <div class="radio-item" v-if="!(bankItem.isOutageApplicable && bankItem.isOutageApplicable === 'DOWN')">
                  <input :id="bankItem.value" name="radio" type="radio" class="custom-control-input-tapan" :value="bankItem.value" v-model="bank">
                  <label :for="bankItem.value"></label>
                </div>
              </div>
            </div>
            <div
              v-if="bankItem.isOutageApplicable === 'DOWN' && bannerPlaceHolderFoPayMethodDown"
              :style="`background-color: ${bannerPlaceHolderFoPayMethodDown.banner_color };`"
            >
              <p
                class="nb-message"
                :style="`color: ${bannerPlaceHolderFoPayMethodDown.banner_text_color };`"
              >
                {{bannerPlaceHolderFoPayMethodDown.description}}
              </p>
            </div>
            <div v-if="bankItem.isOutageApplicable === 'FLUCTUATE' && bannerPlaceHolderFoPayMethodFluctuating">
              <p class="nb-message"
                :style="`color: ${bannerPlaceHolderFoPayMethodFluctuating.banner_text_color };`"
              >
                {{bannerPlaceHolderFoPayMethodFluctuating.description}}
              </p>
            </div>
          </label>
      </div>
      <div class="col-sm-4 dd-wrapper">
        <select class="dd-bank" v-model="bank">
          <option disabled value="<>">Select other bank</option>
          <option v-for="(bankItem, index) in this.netBankingDropdownOutageData" :key="index"
            :value="bankItem.value"
            :disabled="(bankItem.isOutageApplicable && bankItem.isOutageApplicable === 'DOWN')"
          >
           {{ bankItem.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>


<script>
  var $ = require('jquery')
  import {mapGetters} from 'vuex'

  window.jQuery = $
  export default {
    name: 'netBankingInput',
    props: ['callerComp', 'payopt'],
    data () {
      return {
        bank: '<>',
        imgHighLight: null
      }
    },
    methods: {
      imgHighlightHandler (e) {
        this.imgHighLight = e
      }
    },
    computed: {
      ...mapGetters(['netbanking', 'icon_nb', 'bannerPlcaeHolderData', 'payMethodsOutage']),
      bannerPlaceHolderWithoutNBWeb: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'ICON_NB_WEB'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      getBankName () {
        let bankName = this.icon_nb && this.icon_nb.filter(item => {
          return item.payment_type === this.bank
        })
        if (bankName.length) {
          return bankName[0]
        } else {
          let netBanking = this.netbanking && this.netbanking.filter(item => {
            return item.value === this.bank
          })
          if (netBanking.length) {
            return netBanking[0]
          }
        }
      },
      bannerPlaceHolderFoPayMethodFluctuating () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_FLUCTUATING'.toLowerCase())
      },
      bannerPlaceHolderFoPayMethodDown () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_DOWN'.toLowerCase())
      },
      allNetBankingOutage () {
        return this.payMethodsOutage && this.payMethodsOutage.filter(itm => itm.payment_method_type === 'NB')
      },
      netBankingIconOutageData () {
        if (this.allNetBankingOutage && this.allNetBankingOutage.length) {
          return this.icon_nb && this.icon_nb.map((iconItm) => {
            let specificData = this.allNetBankingOutage && this.allNetBankingOutage.filter(subData => (subData.payment_method).toUpperCase() === (iconItm.value).toUpperCase())
            specificData && specificData.length ? iconItm['isOutageApplicable'] = specificData[0].status : ''
            return iconItm
          })
        }
        return this.icon_nb
      },
      netBankingDropdownOutageData () {
        if (this.allNetBankingOutage && this.allNetBankingOutage.length) {
          return this.netbanking && this.netbanking.map((dropdownItm) => {
            let specificData = this.allNetBankingOutage && this.allNetBankingOutage.filter(subData => (subData.payment_method).toUpperCase() === (dropdownItm.value).toUpperCase())
            specificData && specificData.length ? dropdownItm['isOutageApplicable'] = specificData[0].status : ''
            return dropdownItm
          })
        }
        return this.netbanking
      }
    },
    watch: {
      bank (bankName) {
        let nonRadioPayArr = ['cod', 'prepaid', 'cred', 'dcc']
        if (nonRadioPayArr.indexOf(this.payopt) === -1) {
          this.$store.commit('GTAG_EVENT', {eventName: 'PAYMENT_METHOD_SELECT',
            payload: {
              type: this.$parent.getPaymentName(this.$parent.payopt),
              method: (this.getBankName.name || 'NA')
            }}
          )
        }
        this.imgHighlightHandler(bankName)
      },
      payopt () {
        if (this.payopt !== 'nb') {
          this.bank = '<>'
          this.imgHighLight = null
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .content {
    margin: 10px 20px;
    padding-top: 0px;
  }

  img {
    width: 100%;
  }

  .dd-wrapper {
    text-align: center;
  }

  .dd-bank {
    width: 90%;
    border: 1px solid #ededed;
    border-radius: 4px;
    margin-top: 20px;
    padding: 8px 14px;
    background: none;
  }

  .nb-message {
    padding: 5px 15px;
    white-space: normal;
  }
  .wallet {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  
.wallet {
    padding: 0;
    text-align: center;
    margin-bottom:25px;
  }
.custom-control {
    margin-right: 0;
  }
.waltcol026{width:100%}
.wal15{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
.left_img65{display: flex;  align-items: center;}
.left_img65 span{ color:#58595b}  
.image-wrapper {
    border:0;
    border-radius: 50%;
    padding:0px;
    margin: 0;
    width: 40px;
    height:40px;
    margin-right: 18px;
    box-shadow: 0 0 5px #d9caca;           
    overflow: hidden;
  }
  .image-wrapper-highlight {
    border: 3px solid #117a7a !important;
  }
 .image-wrapper:hover,
  input[type="radio"]:checked + .image-wrapper {
    border-color: #ed2e30;
  }
 .radio-item {
  display: inline-block;
  position: relative;
  padding: 0 6px;
  margin-top: 4px;
}

.radio-item input[type='radio'] {
  display: none;
}

.radio-item label {
  color: #666;
  font-weight: normal;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 18px;
  height: 18px;
  border-radius: 11px;
  border: 2px solid #ccc;;
  background-color: transparent;
  cursor: pointer;
}
.radio-item input[type=radio]:checked + label:before {
  border: 2px solid #117a7a !important;
}
.radio-item input[type=radio]:checked + label:after {
  border-radius: 11px;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 9px;
  left: 10px;
  content: " ";
  display: block;
  background: #117a7a;
  cursor: pointer;
}
.custom-control-input-tapan{border-color: aqua;width: 18px;height: 18px;}

  @media screen and (max-width: 991px) {
    .content {
      margin: 10px 0;
    }
  }
  @media (min-width: 991px) {
    .wallet {
        margin-right: 10px;
      }
  }
  @media screen and (max-width: 767px) {
    .wallet{display: block;}
    .waltcol026{display: flex;}
    .wal15{width:100%; padding: 0 10px;}
  }
</style>



// WEBPACK FOOTER //
// netBankingInput.vue?3449f124